module.exports = __webpack_public_path__ + "img/nature-41.9586f0b7.jpg";